module.exports = __webpack_public_path__ + "static/media/jacktop-banner-girl.a3c49ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/jacktop-games/jacktop-banner-girl.png
// module id = 902
// module chunks = 7